var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"uparrow"}},[_c('b-img',{attrs:{"src":_vm.image,"fluid":"","alt":"Up Arrow"},on:{"click":_vm.scrollToTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }